"use client";

import { FilterBar } from "@/features/products/ProductListingPage/Filters";
import { SearchForm } from "@/features/navigation/Search/Search";
import { Suspense } from "react";
import { useSearchCounts } from "./SearchResults";
import { getActiveTab, type SearchTab } from "../utils/searchTabs";
import { withSearchParams } from "@/components/withSearchParams";

export const ConditionalFilterBar = withSearchParams<{}>(({ searchParams }) => {
	const counts = useSearchCounts(searchParams);

	const requestedTab = searchParams.get("tab") as SearchTab | null;
	const currentTab = getActiveTab(requestedTab, counts);

	if (currentTab !== "products") {
		return null;
	}

	return (
		<Suspense>
			<FilterBar>
				<SearchForm />
			</FilterBar>
		</Suspense>
	);
});
